// extracted by mini-css-extract-plugin
export var colorBlack = "#000";
export var colorGray = "gray";
export var colorDarkGray = "#262626";
export var colorLightGray = "#e5e5e5";
export var colorWhite = "#fff";
export var colorElectricBlue = "#0000fe";
export var colorPastelBlue = "#bbe5fe";
export var colorCandyPink = "#f9709a";
export var colorPastelPink = "#ffcdd2";
export var colorDefaultLime = "#cef564";
export var colorPastelLime = "#eeffbe";
export var colorBlueLagoon = "#9cf0e1";
export var colorPastelLagoon = "#ceffec";
export var colorDefaultLavender = "#8738f6";
export var colorPastelLavender = "#eadcff";
export var colorBrightYellow = "#ffe500";
export var colorDefaultGreen = "#12b968";
export var breakpointMedium = "768px";
export var breakpointDesktop = "1024px";
export var breakpointLarge = "1440px";
export var colCount = "6";
export var colWidth = "16.6666666667%";
export var fullscreenBg = "FeedbackForm-module--fullscreenBg--17hwf";
export var container = "FeedbackForm-module--container--j-w91";
export var buttons = "FeedbackForm-module--buttons--2zSnE";
export var buttonsWide = "FeedbackForm-module--buttonsWide--_lyoJ";
export var buttonText = "FeedbackForm-module--buttonText--1M-Eg";
export var icon = "FeedbackForm-module--icon--3hMLt";
export var button = "FeedbackForm-module--button--yqjyX";
export var hearts = "FeedbackForm-module--hearts--3XbZG";
export var heartContainer = "FeedbackForm-module--heartContainer--3VhhY";
export var heart = "FeedbackForm-module--heart--1X0Iz";
export var confirmationContainer = "FeedbackForm-module--confirmationContainer--3dHqA";
export var animateHearts = "FeedbackForm-module--animateHearts--1Igcx";
export var reveal = "FeedbackForm-module--reveal--1owJ5";